import * as React from 'react';
import { ITerritoryConfiguration } from '../types/apiSchema';

export interface IAffiliateDetails {
  isOpenSite?: boolean;
  baseUrl?: string;
  urlString?: string;
  isWhiteLabel: boolean;
}

export interface IApplication {
  affiliateCode: string;
  territoryCode: string;
  userTerritoryCode: string;
  territoryConfig: ITerritoryConfiguration;
  affiliateConfig: IAffiliateDetails;
  currency: string;
  featureFlags: string[];
  isRebookingEnabled?: boolean;
}

export const defaultApplication: IApplication = null;

export const ApplicationContext: React.Context<IApplication> = React.createContext(
  defaultApplication
);

ApplicationContext.displayName = 'ApplicationContext';
